/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {InputModule} from '../../shared/input/input.module';
import {CommonModule} from '@angular/common';
import {SettlementDetailInformationComponent} from './settlement-detail-information.component';
import {SettlementDetailTitleModule} from '../settlemente-detail-title/settlement-detail-title.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {StatusTimelineModule} from '../../shared/status-timeline/status-timeline.module';

@NgModule({
    imports: [
        CommonModule,
        InputModule,
        SettlementDetailTitleModule,
        PipesModule,
        StatusTimelineModule
    ],
    declarations: [SettlementDetailInformationComponent],
    exports: [SettlementDetailInformationComponent]
})

export class SettlementDetailInformationModule {
}
